/* Threaded Co. — Custom Order form
   Multi-item version: each item (product type, decoration, quantity, sizes,
   description, artwork) is cloned from a <template>, so a single order can
   contain several different products — e.g. two shirt styles and hats —
   each fully specified on its own. Name/Email/Phone and one "Need it by"
   date stay global for the whole order. Submission is delivered by
   Shopify's native contact form; every item's fields are written into
   uniquely-named hidden contact[] fields (e.g. "Item 2 - Quantity") so the
   store owner receives everything, clearly separated, in the notification
   email. The embroidery digitizing fee notice only shows on an item once
   its Decoration type is set to Embroidery. */
(function () {
  'use strict';

  var root = document.getElementById('custom-order');
  if (!root) return;

  var form = document.getElementById('OrderForm');
  var cloudName = root.dataset.cloudName || '';
  var uploadPreset = root.dataset.uploadPreset || '';
  var minLeadDays = parseInt(root.dataset.minLeadDays, 10) || 15;

  /* ---- Success state (after Shopify redirects back) ---- */
  var posted = root.querySelector('[data-order-posted]');
  var successCard = root.querySelector('[data-order-success]');
  if (posted && successCard && form) {
    form.hidden = true;
    successCard.hidden = false;
    var emailSlot = successCard.querySelector('[data-success-email]');
    var savedEmail = '';
    try { savedEmail = sessionStorage.getItem('tc_order_email') || ''; } catch (e) {}
    if (emailSlot) emailSlot.textContent = savedEmail || 'your email';
    successCard.scrollIntoView({ block: 'center' });
    var reset = successCard.querySelector('[data-reset-form]');
    if (reset) {
      reset.addEventListener('click', function (e) {
        e.preventDefault();
        successCard.hidden = true;
        form.hidden = false;
        form.reset();
        form.scrollIntoView({ block: 'start' });
      });
    }
  }

  if (!form) return;

  /* ---- "Need it by" minimum date: gray out anything before N business days out ---- */
  function addBusinessDays(startDate, days) {
    var result = new Date(startDate.getTime());
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      var day = result.getDay(); // 0 = Sun, 6 = Sat
      if (day !== 0 && day !== 6) added++;
    }
    return result;
  }
  function formatDateInputValue(d) {
    var y = d.getFullYear();
    var m = ('0' + (d.getMonth() + 1)).slice(-2);
    var day = ('0' + d.getDate()).slice(-2);
    return y + '-' + m + '-' + day;
  }

  var needByInput = form.querySelector('[data-field="need-by"]');
  var minDateHint = form.querySelector('[data-min-date-hint]');
  var minDate = addBusinessDays(new Date(), minLeadDays);
  var minDateValue = formatDateInputValue(minDate);

  if (needByInput) {
    needByInput.setAttribute('min', minDateValue);
  }
  if (minDateHint) {
    var friendly = minDate.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
    minDateHint.textContent = 'Earliest available date: ' + friendly + ' (production takes at least ' + minLeadDays + ' business days).';
  }

  /* ---- Multi-item repeating blocks ---- */
  var itemsContainer = form.querySelector('[data-order-items]');
  var addItemBtn = form.querySelector('[data-add-item]');
  var itemTemplate = document.getElementById('OrderItemTemplate');
  var itemUploads = new WeakMap(); // itemEl -> [{ id, name, url }]

  function renumberItems() {
    var itemEls = itemsContainer.querySelectorAll('[data-order-item]');
    itemEls.forEach(function (itemEl, idx) {
      var n = idx + 1;
      var numberSlot = itemEl.querySelector('[data-item-number]');
      if (numberSlot) numberSlot.textContent = n;

      itemEl.querySelectorAll('[data-field-key]').forEach(function (field) {
        var key = field.getAttribute('data-field-key');
        field.setAttribute('name', 'contact[Item ' + n + ' - ' + key + ']');
      });

      var removeBtn = itemEl.querySelector('[data-remove-item]');
      if (removeBtn) removeBtn.style.display = itemEls.length > 1 ? '' : 'none';
    });
  }

  function addItem() {
    var fragment = itemTemplate.content.cloneNode(true);
    var itemEl = fragment.querySelector('[data-order-item]');
    itemUploads.set(itemEl, []);
    itemsContainer.appendChild(fragment);
    renumberItems();
  }

  function removeItem(itemEl) {
    var itemEls = itemsContainer.querySelectorAll('[data-order-item]');
    if (itemEls.length <= 1) return; // always keep at least one item
    itemEl.remove();
    renumberItems();
  }

  if (addItemBtn) {
    addItemBtn.addEventListener('click', addItem);
  }

  // Seed the form with exactly one item block on load.
  addItem();

  /* ---- Chip groups -> hidden inputs (event-delegated, works for every cloned item) ---- */
  itemsContainer.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-chip]');
    if (!chip) return;
    var group = chip.closest('[data-chip-group]');
    if (!group) return;
    var itemEl = chip.closest('[data-order-item]');
    var groupKey = group.getAttribute('data-chip-group');
    var hidden = itemEl.querySelector('[data-chip-value="' + groupKey + '"]');

    chip.classList.toggle('is-active');
    var active = [].map.call(group.querySelectorAll('.is-active'), function (c) {
      return c.getAttribute('data-chip');
    });
    if (hidden) hidden.value = active.join(', ');

    // Show the embroidery digitizing fee notice on this item only while
    // "Embroidery" is one of the selected decoration types.
    if (groupKey === 'deco') {
      var notice = itemEl.querySelector('[data-embroidery-notice]');
      if (notice) {
        var hasEmbroidery = active.some(function (val) {
          return val.trim().toLowerCase() === 'embroidery';
        });
        notice.classList.toggle('is-visible', hasEmbroidery);
      }
    }
  });

  /* ---- Remove item button ---- */
  itemsContainer.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-remove-item]');
    if (!removeBtn) return;
    var itemEl = removeBtn.closest('[data-order-item]');
    if (itemEl) removeItem(itemEl);
  });

  /* ---- Dropzone + Cloudinary uploads (per item, event-delegated) ---- */
  function syncUrls(itemEl) {
    var urlsInput = itemEl.querySelector('[data-upload-urls]');
    var uploads = itemUploads.get(itemEl) || [];
    if (urlsInput) {
      urlsInput.value = uploads
        .map(function (u) { return u.url ? u.name + ': ' + u.url : u.name + ' (not uploaded)'; })
        .join('\n');
    }
    var uploadList = itemEl.querySelector('[data-upload-list]');
    if (uploadList) uploadList.hidden = uploads.length === 0;
  }

  function setStatus(item, text, cls) {
    var status = item.querySelector('.upload-item__status');
    status.textContent = text;
    status.className = 'upload-item__status' + (cls ? ' upload-item__status--' + cls : '');
  }

  function uploadFile(file, itemEl) {
    var id = Math.random().toString(36).slice(2);
    var entry = { id: id, name: file.name, url: '' };
    var uploads = itemUploads.get(itemEl) || [];
    uploads.push(entry);
    itemUploads.set(itemEl, uploads);

    var item = document.createElement('div');
    item.className = 'upload-item';
    item.innerHTML =
      '<div class="upload-item__thumb"></div>' +
      '<div class="upload-item__meta">' +
        '<span class="upload-item__name"></span>' +
        '<span class="upload-item__status">Uploading…</span>' +
      '</div>' +
      '<button type="button" class="upload-item__remove" aria-label="Remove file">✕</button>';
    item.querySelector('.upload-item__name').textContent = file.name;
    if (file.type.indexOf('image/') === 0) {
      item.querySelector('.upload-item__thumb').style.backgroundImage =
        'url("' + URL.createObjectURL(file) + '")';
    }
    item.querySelector('.upload-item__remove').addEventListener('click', function () {
      var current = itemUploads.get(itemEl) || [];
      itemUploads.set(itemEl, current.filter(function (u) { return u.id !== id; }));
      item.remove();
      syncUrls(itemEl);
    });

    var uploadList = itemEl.querySelector('[data-upload-list]');
    uploadList.appendChild(item);
    syncUrls(itemEl);

    if (!cloudName || !uploadPreset) {
      setStatus(item, 'Attached (connect Cloudinary in theme settings)', 'warn');
      return;
    }

    var fd = new FormData();
    fd.append('file', file);
    fd.append('upload_preset', uploadPreset);
    fetch('https://api.cloudinary.com/v1_1/' + cloudName + '/auto/upload', { method: 'POST', body: fd })
      .then(function (res) {
        if (!res.ok) throw new Error('upload failed');
        return res.json();
      })
      .then(function (data) {
        entry.url = data.secure_url;
        setStatus(item, 'Uploaded ✓', 'ok');
        syncUrls(itemEl);
      })
      .catch(function () {
        setStatus(item, 'Upload failed — we still noted the file', 'err');
        syncUrls(itemEl);
      });
  }

  function handleFiles(fileList, itemEl) {
    [].forEach.call(fileList, function (file) { uploadFile(file, itemEl); });
  }

  itemsContainer.addEventListener('click', function (e) {
    var dropzone = e.target.closest('[data-dropzone]');
    if (!dropzone) return;
    var itemEl = dropzone.closest('[data-order-item]');
    var fileInput = itemEl.querySelector('[data-file-input]');
    if (fileInput) fileInput.click();
  });

  itemsContainer.addEventListener('keydown', function (e) {
    var dropzone = e.target.closest('[data-dropzone]');
    if (!dropzone) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      var itemEl = dropzone.closest('[data-order-item]');
      var fileInput = itemEl.querySelector('[data-file-input]');
      if (fileInput) fileInput.click();
    }
  });

  itemsContainer.addEventListener('dragover', function (e) {
    var dropzone = e.target.closest('[data-dropzone]');
    if (!dropzone) return;
    e.preventDefault();
    dropzone.classList.add('is-dragover');
  });

  itemsContainer.addEventListener('dragleave', function (e) {
    var dropzone = e.target.closest('[data-dropzone]');
    if (!dropzone) return;
    dropzone.classList.remove('is-dragover');
  });

  itemsContainer.addEventListener('drop', function (e) {
    var dropzone = e.target.closest('[data-dropzone]');
    if (!dropzone) return;
    e.preventDefault();
    dropzone.classList.remove('is-dragover');
    var itemEl = dropzone.closest('[data-order-item]');
    handleFiles(e.dataTransfer.files, itemEl);
  });

  itemsContainer.addEventListener('change', function (e) {
    if (!e.target.matches('[data-file-input]')) return;
    var itemEl = e.target.closest('[data-order-item]');
    handleFiles(e.target.files, itemEl);
    e.target.value = '';
  });

  /* ---- Validation (on submit only, per spec) ---- */
  var errorBox = form.querySelector('[data-form-error]');
  form.addEventListener('submit', function (e) {
    var name = form.querySelector('[data-field="name"]').value.trim();
    var email = form.querySelector('[data-field="email"]').value.trim();
    var errors = [];

    if (!name) errors.push('your name');
    if (!email) errors.push('your email');

    if (needByInput && needByInput.value && needByInput.value < minDateValue) {
      errors.push('a "Need it by" date at least ' + minLeadDays + ' business days out');
    }

    var itemEls = itemsContainer.querySelectorAll('[data-order-item]');
    itemEls.forEach(function (itemEl, idx) {
      var n = idx + 1;
      var productsPicked = itemEl.querySelectorAll('[data-chip-group="products"] .is-active').length;
      var qty = itemEl.querySelector('[data-field="qty"]').value.trim();
      if (productsPicked === 0) errors.push('a product type for Item ' + n);
      if (!qty) errors.push('a quantity for Item ' + n);
    });

    if (errors.length > 0) {
      e.preventDefault();
      if (errorBox) {
        errorBox.textContent = 'Please fill in: ' + errors.join(', ') + '.';
        errorBox.hidden = false;
        errorBox.scrollIntoView({ block: 'center' });
      }
      return;
    }

    if (errorBox) errorBox.hidden = true;
    try { sessionStorage.setItem('tc_order_email', email); } catch (err) {}

    // Give any in-flight uploads a moment; URLs sync into hidden fields as they land.
    // We still submit — failed files are listed by name so nothing is lost silently.
    itemEls.forEach(function (itemEl) { syncUrls(itemEl); });
  });
})();